module.exports = __webpack_public_path__ + "img/badminton.64aae059.svg";